<template>
  <div>
    <a-modal :visible="true" title="Business Type Units" width="600px" okText="Update/Create Unit Type" @cancel="closeModal" @ok="submit">
      <a-spin :spinning="Status === 'updatingUnitType'">
        <a-form :form="form" class="buisnessUnitTypes">
          <a-form-item>
            <label>Select an option:</label>
            <a-select
              v-decorator="['option', { initialValue: 0, rules: [{ required: true, message: 'Please select a option!' }] }]"
              @change="setNameValue"
            >
              <a-select-option :value="0">
                Create new type
              </a-select-option>
              <a-select-option v-for="unitType in UnitTypes" :value="unitType.unit_type_id" :key="unitType.unit_type_id">
                {{ unitType.unit_type_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <label> Unit type name:</label>
            <a-input v-decorator="['name', { rules: [{ required: true, message: 'Please enter name!' }] }]" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BuisnessUnitTypes',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'buisnessUnitsForm' }),
    };
  },
  methods: {
    setNameValue(val) {
      this.form.setFieldsValue({ name: this.UnitTypes.find(({ unit_type_id }) => unit_type_id === val)?.unit_type_name ?? '' });
    },
    closeModal() {
      this.$store.dispatch('businessUnits/updateOpenModal', '');
    },
    submit() {
      this.form.validateFields((errors, { name, option }) => {
        if (!errors) {
          this.$store
            .dispatch(`businessUnits/${option ? 'editUnitType' : 'addUnitType'}`, {
              name,
              customerId: this.Customer.customerid,
              unitTypeId: option,
            })
            .then(() => {
              this.$store.dispatch('businessUnits/getUnitTypes');
              this.closeModal();
            });
        }
      });
    },
  },

  computed: {
    ...mapState({
      UnitTypes: (state) => state.businessUnits.UnitTypes,
      Status: (state) => state.businessUnits.Status,
      Customer: (state) => state.businessUnits.Customer,
    }),
  },
};
</script>
<style lang="scss">
.buisnessUnitTypes {
  .ant-form-item {
    margin-bottom: 10px;
    .ant-form-item-children {
      @mixin form-field {
        background-color: #f0f9ff !important;
        height: calc(1.5em + 1rem);
        border-radius: 0.4rem;
        border: 0 solid #ced4da !important;
        box-shadow: inset 1px 1px 3px rgb(157 193 216 / 50%);
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      }
      .ant-select,
      & > .ant-input {
        width: 100%;
        min-width: 20px;
      }
      .ant-select-selection.ant-select-selection--single,
      & > .ant-input {
        @include form-field();
        .ant-select-selection__rendered {
          line-height: 36px;
        }
      }
    }
  }
}
</style>
